import { useCallback } from 'react';
import { ProjectId, User } from 'api/models';
import { useProjectDetail } from 'data/projects';
import { fullName } from 'utils/full-name';
import { sortByText } from 'utils/sort-by-text';

interface Props {
  projectId: number;
}
export const useSortProjectMembers = ({ projectId }: Props) => {
  const { data: project } = useProjectDetail(ProjectId(projectId));
  const projectOwnerId = project?.projectOwner?.userId;
  const sortProjectMembers = useCallback(
    (users: User[]) => {
      return users.sort((userA, userB) => {
        if (userA.userId === projectOwnerId) {
          return -1;
        }
        if (userB.userId === projectOwnerId) {
          return 1;
        }

        return sortByText(fullName(userA), fullName(userB));
      });
    },
    [projectOwnerId],
  );

  return {
    projectOwnerId,
    sortProjectMembers,
  };
};
